import React from 'react';
import { connect } from 'react-redux';
import { FPSStats } from 'react-stats';
import Notifications from 'react-notification-system-redux';
import { DragDropContext } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import Radium from 'radium';
import PropTypes from 'prop-types';
import StylePropType from 'react-style-proptype';
import Styles from './styles';
import LoadingOverlay from '../../components/LoadingOverlay';

const __DEV__ = false;

class AppWrapper extends React.Component {
  renderLoading() {
    return <LoadingOverlay />;
  }

  render() {
    const { notifications } = this.props;
    const style = Styles.Notifications;

    if (this.props.isFirebaseInitializing || !this.props.isFirebaseAuthLoaded) {
      return this.renderLoading();
    }

    return (
      <div style={[Styles.wrapper, this.props.style]}>
        <FPSStats isActive={__DEV__} />
        <Notifications notifications={notifications} style={style} />
        {this.props.children}
      </div>
    );
  }
}

AppWrapper.propTypes = {
  notifications: PropTypes.array,
  style: StylePropType,
  isFirebaseInitializing: PropTypes.bool,
  isFirebaseAuthLoaded: PropTypes.bool,
};

AppWrapper.defaultProps = {
  notifications: [],
  style: {},
  isFirebaseInitializing: true,
  isFirebaseAuthLoaded: false,
};

const mapStateToProps = state => ({
  notifications: state.notifications,
  isFirebaseInitializing: state.firebase.isInitializing,
  isFirebaseAuthLoaded: state.firebase.auth.isLoaded,
});

const mapDispatchToProps = dispatch => ({
  // reserved for future use
});

export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(
  DragDropContext(HTML5Backend)(Radium(AppWrapper)),
);



// WEBPACK FOOTER //
// ./src/containers/AppWrapper/index.js